// extracted by mini-css-extract-plugin
export default {"root":"CzeWGT107Of_IMRjdQFg","access-issues__label":"yOyzbuL8KVaklbE6pZyW"};